// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__G8Mrs","choiceBoxes":"toolbarselects_choiceBoxes__3KgfS","simpleField":"toolbarselects_simpleField__2vhB4"};